import React from 'react';

const LandLineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11.055" height="11" viewBox="0 0 11.055 11">
    <path d="M653.044,2497.608a2.8,2.8,0,0,1-.315,1.035,2.038,2.038,0,0,1-.686.719c-1.68,1.086-3.713.093-5.244-.8a11.975,11.975,0,0,1-3.495-3.463c-.907-1.523-1.919-3.547-.848-5.237a2.038,2.038,0,0,1,.712-.693,2.808,2.808,0,0,1,1.032-.324.469.469,0,0,1,.527.274c.338.612.691,1.215,1.033,1.825a3.431,3.431,0,0,1,.212.449.373.373,0,0,1-.129.466c-.348.317-.7.636-1.032.964a.39.39,0,0,0-.079.57,7.932,7.932,0,0,0,1.544,2.2h0l0,0,0,0h0a7.924,7.924,0,0,0,2.209,1.524.512.512,0,0,0,.357.072.52.52,0,0,0,.212-.156c.326-.34.641-.69.955-1.041a.373.373,0,0,1,.465-.134,3.417,3.417,0,0,1,.451.208c.613.336,1.22.684,1.835,1.016A.469.469,0,0,1,653.044,2497.608Z" transform="translate(-641.995 -2488.837)"/>
  </svg>
);
export default LandLineIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/LandLineIcon.js